import { Condition } from '../conditions';

export interface Rule {
  conditionLogic: ConditionLogicEnum.And;
  conditions: Condition[];
  treatment: TreatmentEnum;
}

export enum ConditionLogicEnum {
  And = 'and',
}

export enum TreatmentEnum {
  True = 'true',
  False = 'false',
}

export enum RuleEvaluationResultEnum {
  Treatable = 'treatable',
  Insufficient = 'insufficient',
}

export interface CreateRuleEvaluatorPayload {
  rule: Rule;
}

export type RuleEvaluator = (attributes: Record<string, unknown>) => RuleEvaluationResultEnum;
